module.exports = __webpack_public_path__ + "static/img/coupon_icon02.81a5aa13.svg";